import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { LogoComponent } from './header/logo/logo.component';
import { NavigationComponent } from './header/navigation/navigation.component';
import { CreateSpriteHeaderButtonComponent } from './header/nav-buttons/create-sprite-header-button/create-sprite-header-button.component';
import { SignInHeaderButtonComponent } from './header/nav-buttons/sign-in-header-button/sign-in-header-button.component';
import { NavButtonsComponent } from './header/nav-buttons/nav-buttons.component';
import { AboutComponent } from './about/about.component';
import { CreateSpriteAboutButtonComponent } from './about/create-sprite-about-button/create-sprite-about-button.component';
import { LogInAboutButtonComponent } from './about/signin-about-button/log-in-about-button.component';
import { ExampleComponent } from './example/example.component';
import { FeaturesComponent } from './features/features.component';
import { AuthorComponent } from './author/author.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LogoComponent,
    NavigationComponent,
    CreateSpriteHeaderButtonComponent,
    SignInHeaderButtonComponent,
    NavButtonsComponent,
    AboutComponent,
    CreateSpriteAboutButtonComponent,
    LogInAboutButtonComponent,
    ExampleComponent,
    FeaturesComponent,
    AuthorComponent
  ],
  imports: [
    BrowserModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
